<template>
  <div class="leftres">
    <div>
      <div class="TableBox" style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); background-color: #FFFFFF;">
        <dataManagetable ></dataManagetable>
      </div>
    </div>
  </div>
</template>

<script>
import Commondropdownlist from '../../../components/common-dropdownlist.vue'
import CommonBtngroup from '../../../components/commongroup.vue'
import dataManagetable from './components/dataManagetable.vue'
import { GetMenusWithAuthorites, OrganizationList  } from '@/api/home'
export default {
  components: {
    Commondropdownlist,
    CommonBtngroup,
    dataManagetable
  },
  data() {
    return {
    }
  },
  mounted() {
    
  },
  methods: {
   
  }
}
</script>

<style lang="less" scoped>
.inputtop {
  width: 980px;
  height: 0px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 70px;
  animation: shows 0.2s ease-in;
  overflow: hidden;
}
.inputtops {
  width: 980px;
  height: 0;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 70px;
  overflow: hidden;
  // animation: hides 0.5s ease-in;
}
@keyframes shows {
  0% {
    height: 0px;
  }
  100% {
    height: 40px;
  }
}
@keyframes hides {
  0% {
    height: 40px;
  }
  100% {
    height: 0px;
  }
}
</style>